module.exports = [{"id":1,"label":"item 1"},{"id":2,"label":"item 2"}]


//////////////////
// WEBPACK FOOTER
// ./src/app/mock/fakeAPI.json
// module id = 568
// module chunks = 0